<template>
    <div>
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <div class="cart pb-5 pt-2 pt-md-4">
            <b-container class="cart-card pb-md-5 pb-lg-0">
                <div class="cart-title mb-4"> Minha cesta de compras</div>
                <div class="mb-4 d-md-none">
                    <nuxt-link to="/">&#171; Continuar comprando</nuxt-link>
                </div>
                <div v-if="!$store.state.order.order.produtos.length" class="text-center">
                    Sua cesta de compras está vazia
                </div>
                <div v-if="$store.state.order.order.produtos.length">
                    <div class="alert alert-warning alert-dismissible fade show" role="alert" v-if="isOrderGiftList">
                        Você está comprando em uma lista de presentes
                    </div>
                    <b-row class="cart-table-header mr-0 ml-0">
                        <b-col md="5" class="py-3">
                            Produto
                        </b-col>
                        <b-col>
                            <b-row>
                                <b-col md="3" class="py-3 text-center">
                                    Preço
                                </b-col>
                                <b-col md="4" class="py-3 text-center">
                                    Quantidade
                                </b-col>
                                <b-col md="5" class="py-3 text-center">
                                    Total
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <div class="cart-products-border pb-2 pb-lg-5 mb-4">
                        <div v-for="product in $store.state.order.order.produtos" class="cart-product-border py-md-2">
                            <ProductCart :product="product" :errors="cartErrors.products[product.id]" @show-modal="showModal"/>
                        </div>
                        <b-row class="mt-4">
                            <b-col lg="4">
                                <CartShipping/>
                            </b-col>
                            <b-col lg="4">
                                <DiscountCoupon/>
                            </b-col>
                            <b-col lg="4">
                                <div class="mb-3 mr-3 ml-3 ml-lg-0" :class="{ 'cart-minimun-value': minimum_order_value > 0 && minimum_order_value > subtotal}">
                                    <div class="d-flex justify-content-between">
                                        <div class="cart-name-value-order">
                                            Subtotal
                                        </div>
                                        <div class="cart-name-value-order">
                                            {{ subtotal | currency }}
                                        </div>
                                    </div>
                                    <div class="cart-text-minimun text-right" v-if="parseFloat(minimum_order_value) > 0 && parseFloat(minimum_order_value) > parseFloat(subtotal)" >*pedido mínimo de {{minimum_order_value | currency}}</div>
                                </div>
                                <div class="d-flex justify-content-between mb-3 mr-3 ml-3 ml-lg-0">
                                    <div class="cart-name-value-order">
                                        Frete
                                    </div>
                                    <div class="cart-name-value-order">
                                        {{ freight | currency }}
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between mb-3 mr-3 ml-3 ml-lg-0">
                                    <div class="cart-name-value-order">
                                        Cupom desconto
                                    </div>
                                    <div class="cart-discount-value">
                                        {{ discount_coupon | currency }}
                                    </div>
                                </div>
                                <hr class="mr-3 ml-3 ml-lg-0">
                                <div class="mb-3 mr-3 ml-3 ml-lg-0">
                                    <div class="d-flex justify-content-between">
                                        <div class="cart-total-order-value">
                                            Total
                                        </div>
                                        <div class="cart-total-order-value">
                                            {{ total | currency }}
                                        </div>
                                    </div>
                                    <div class="text-right" v-if="$wdconfig.modules.product.payment_discount && $store.state.order.order.payments && $store.state.order.order.payments.length">
                                        ou <b>{{ $store.state.order.order.payments[0]['amount'] | currency}}</b> no <b>{{ $store.state.order.order.payments[0]['name'] }}</b>
                                    </div>
                                    <div class="text-right" v-if="$store.state.order.order.payment_condition && $store.state.order.order.payment_condition.installments > 1">
                                        ou em até
                                        <b>{{$store.state.order.order.payment_condition.installments}} x de {{$store.state.order.order.payment_condition.amount | currency}}</b>
                                        sem juros
                                    </div>
                                </div>
                                <hr class="d-none d-lg-block mr-3 ml-3 ml-lg-0">
                            </b-col>
                        </b-row>
                    </div>
                    <div class="d-none d-md-flex justify-content-between flex-column flex-md-row pb-5 pb-md-0">
                        <div class="d-none d-md-block">
                            <div class="options-cart">
                                <nuxt-link to="/" class="btn-default btn-square btn-keep-buying d-block">
                                    CONTINUAR COMPRANDO
                                </nuxt-link>
                            </div>
                        </div>
                        <div class="to-checkout">
                            <button @click="redirectCart()" :disabled="!isValidCart" class="btn-default btn-square btn-go-checkout px-5">
                                <span class="px-5">
                                    <span>FINALIZAR COMPRA</span>
                                    <span v-if="sending" class="ml-2">
                                         <b-spinner small label="Carregando"></b-spinner>
                                    </span>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </b-container>
            <div class="cart-fixed-mobile pt-1 d-md-none" v-if="$store.state.order.order.produtos.length">
                <div class="text-center cart-fixed-mobile-itens-qty"> {{ $store.state.order.order.produtos.length }} itens no carrinho</div>
                <div class="d-flex justify-content-center cart-fixed-mobile-total">
                    <div>Total:</div>
                    <div class="ml-2"> {{ total | currency }}</div>
                </div>
                <div class="d-flex justify-content-center">
                    <button @click="redirectCart()" :disabled="!isValidCart" class="btn-default btn-square btn-go-checkout w-75">
                        <span>Finalizar compra</span>
                        <span v-if="sending" class="ml-2"><b-spinner small label="Carregando"></b-spinner></span>
                    </button>
                </div>
            </div>
        </div>
        <ModalObservation :product="product" :key="'modalobservation' + product.id"/>
        <ModalFile :product="product" :key="'modalfile' + product.id"/>
    </div>
</template>
<script>
    import utils from "~/mixins/utils.js";
    import product from '~/mixins/product';
    import ecommerce_shipping from "~/mixins/ecommerce_shipping";
    import ecommerce_cart from "~/mixins/ecommerce_cart.js";
    import {ValidationProvider, ValidationObserver} from "vee-validate";
    import {TheMask} from "vue-the-mask";
    import Breadcrumb from "~/components/Breadcrumb";
    import ProductCart from "~/components/ProductCart";
    import CartShipping from "~/components/CartShipping";
    import DiscountCoupon from "~/components/DiscountCoupon";
    import ModalObservation from "~/components/ModalObservation";
    import ModalFile from "~/components/ModalFile";

    export default {
        head() {
            return {
                title: 'Carrinho',
                meta: [
                    {
                        hid: `twitter:card`,
                        name: 'twitter:card',
                        content: "summary_large_image"
                    },
                    {
                        hid: `og:title`,
                        property: 'og:title',
                        content: 'Carrinho'
                    },
                    {
                        hid: `og:url`,
                        property: 'og:url',
                        content: `${this.$host}${this.$route.fullPath}`
                    },
                    {
                        hid: `og:image`,
                        property: 'og:image',
                        content: this.imageUrl(this.$wdconfig.default.logo)
                    },
                    {
                        hid: 'og:image:height',
                        property: 'og:image:height',
                        content: '315'
                    },
                    {
                        hid: 'og:image:width',
                        property: 'og:image:width',
                        content: '600'
                    },
                ]
            }
        },
        mixins: [
            utils,
            ecommerce_cart,
            ecommerce_shipping,
            product
        ],
        components: {
            ModalFile,
            ModalObservation,
            Breadcrumb,
            ValidationProvider,
            ValidationObserver,
            TheMask,
            ProductCart,
            CartShipping,
            DiscountCoupon
        },
        data() {
            return {
                sending: false,
                product: {},
                cartErrors: {
                    validate: false,
                    products: {}
                }
            }
        },
        computed: {
            breadcrumb() {
                let breadcrumb = [
                    {
                        name: 'Home',
                        link: '/'
                    }
                ];
                breadcrumb.push({
                    name: 'Minha cesta de compras',
                    link: null
                });
                return breadcrumb;
            },
            isValidCart() {
                let is_valid = true
                try {
                    if (typeof this.$store.state.order.order.discount_coupon === 'object') {
                        is_valid = this.$store.state.order.order.discount_coupon.frete_valido === 'sim' || this.$store.state.order.order.discount_coupon.cupom === ''
                    }
                } catch (e) {
                    console.error(e)
                }
                if (is_valid) {
                    is_valid = !(parseFloat(this.$store.state.order.order.minimum_order_value) > 0 && parseFloat(this.$store.state.order.order.minimum_order_value) > parseFloat(this.$store.state.order.order.valor_subtotal))
                }
                return is_valid
            },
            isOrderGiftList() {
                try {
                    let item = this.$store.state.order.order.produtos.find(el => {
                        return el.lista && el.lista.codigo > 0
                    })
                    if (item) {
                        return item.lista
                    }
                } catch (e) {
                    console.error(e)
                }
                return false
            }
        },
        methods: {
            redirectCart() {
                if (this.validCart()) {
                    window.location = '/checkout'
                }
            },
            validCart() {
                this.cartErrors.products = {}
                let is_valid = true
                try {
                    this.$store.state.order.order.produtos.forEach(el => {
                        this.cartErrors.products[el.id] = [];
                        if (el.observacao.ativo && el.observacao.obrigatorio && el.observacao.texto === '') {
                            is_valid = false
                            this.cartErrors.products[el.id].push('É necessário adicionar uma observação')
                        }
                        el.anexos.forEach(anexo => {
                            if (anexo.obrigatorio && anexo.arquivo === '') {
                                is_valid = false
                                this.cartErrors.products[el.id].push('É necessário adicionar um arquivo')
                            }
                        })
                        if (this.isOrderGiftList && el.lista && parseInt(el.lista.codigo) !== parseInt(this.isOrderGiftList.codigo)) {
                            is_valid = false
                            this.cartErrors.products[el.id].push(`Este produto não está na lista "${this.isOrderGiftList.nome}". Remova este item para avançar`)
                        }
                    })
                    this.cartErrors.validate = true
                } catch (e) {
                    console.error(e)
                }
                console.log(is_valid, this.cartErrors)
                return is_valid
            },
            showModal(type, product) {
                this.product = Object.assign({}, product)
                setTimeout(() => {
                    if (type === 'file') {
                        this.$bvModal.show('modal-file')
                    }
                    if (type === 'observation') {
                        this.$bvModal.show('modal-observation')
                    }
                }, 100)
            }
        }
    }
</script>
